<template>
<div>
    <MenuAccount_Main />
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div>
            <v-card class="list_menu_account_report mb-3">
                <router-link to="/dailycostreport" class="menu_card_account_report d-flex flex-column justify-center align-center">
                    <div class="img_menu_account_report">
                        <img src="@/assets/statistics.png">
                    </div>
                    <div class="title_menu_account_report">
                        รายงานต้นทุนรายวัน
                    </div>
                </router-link>
            </v-card>
            <v-card class="list_menu_account_report mb-3">
                <router-link to="/incomestatement" class="menu_card_account_report d-flex flex-column justify-center align-center">
                    <div class="img_menu_account_report">
                        <img src="@/assets/graph.png">
                    </div>
                    <div class="title_menu_account_report">
                        งบกำไรขาดทุน
                    </div>
                </router-link>
            </v-card>
        </div>
    </div>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import MenuAccount_Main from '@/components/menuadmin/account/accountheader/MenuAccount_Main.vue'
export default {
    name: 'accountReport',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    components: {
        MenuAccount_Main,
    },
    data() {
        return {
            loading_page: true
        }
    },
    methods: {
        async buffetList() {
            this.loading_page = true
            HTTP.get('/buffet/list', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
    },
    mounted() {
        this.buffetList()
    }
}
</script>

<style scoped>
.list_menu_account_report {
    width: 100%;
    padding: 15px;
}

.list_menu_account_report:hover {
    background: linear-gradient(to top, #038cc1 , #55c0e9)!important;
    transition: 0.1s !important;
}

.list_menu_account_report:hover>.menu_card_account_report {
    color: #fff !important;
}

.menu_card_account_report {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.87) !important;
}

.img_menu_account_report {
    width: 100px;
}

.img_menu_account_report>img {
    max-width: 100%;
}

.title_menu_account_report {
    font-size: 20px;
}
</style>
